export default __webpack_public_path__ + "static/media/invoice_header.076ba16b.png";